import { Button, Stack } from '@mui/material';
import { Form, TextFieldControl, VALIDATION } from '@myhrbox/myhrbox-frontend-core';
import { authFieldSx } from 'pages/onboarding/styles';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export type InitResetFormData = {
  email: string;
};

type InitResetFormProps = {
  onSubmit: (data: InitResetFormData) => void;
  loading?: boolean;
};

const InitResetForm = ({ onSubmit, loading }: InitResetFormProps) => {
  const { t } = useTranslation();
  const form = useForm<InitResetFormData>();
  const { handleSubmit } = form;

  return (
    <Form form={form}>
      <Stack spacing={3}>
        <TextFieldControl
          name='email'
          label='Email'
          placeholder='Email'
          type='email'
          rules={{
            required: true,
            ...VALIDATION({
              message: t('validation.invalidEmailCharacters'),
              maxLengthMessage: (count) => t('validation.maxLengthExceeded', { count }),
            }).emailFull,
          }}
          disabled={loading}
          sx={authFieldSx}
        />
        <Button variant='contained' size='large' loading={loading} onClick={handleSubmit(onSubmit)}>
          {t('passwordReset.sendCode')}
        </Button>
      </Stack>
    </Form>
  );
};

export default InitResetForm;
